import { useTranslation } from 'libs/i18n';
import { DialogProps } from 'libs/ui';
import { DialogWithdrawalAccountFeature } from 'modules/client/common/components/sections/WithdrawalAccountsSection/FormContent/components/DialogWithdrawalAccountFeature';
import { WithdrawalAccountFormType } from 'modules/client/common/forms/withdrawalAccountForm';

import { FooterActions } from '../FooterActions';

import { useAddDialogWithdrawalAccount } from './hooks/useAddDialogWithdrawalAccount';

interface Props extends DialogProps {
  onClose: () => void;
  onSubmit: (value: WithdrawalAccountFormType) => void;
  readOnly?: boolean;
}

export const DialogAddWithdrawalAccountFeature = ({
  isOpen,
  onClose,
  onSubmit,
  readOnly,
}: Props) => {
  const { initialValues, countries, countriesLoading } =
    useAddDialogWithdrawalAccount();

  const { t } = useTranslation();

  return (
    <DialogWithdrawalAccountFeature
      countries={countries}
      countriesLoading={countriesLoading}
      footerActions={
        <FooterActions
          submitLabel={t('client.client.withdrawalAccounts.addButton')}
          onClose={onClose}
        />
      }
      initialValues={initialValues}
      isOpen={isOpen}
      readOnly={readOnly}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};
